import { PageController } from '@client/components/_core/layout/PageController';
import { RegisterTemplateGallery } from '@client/components/registers/RegisterTemplateGallery';
import { usePermissions } from '@client/hooks/auth/usePermissions';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { trpcOptions } from '@client/trpc/client';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/compliance/registers/_list/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'Add a register',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    const { orgId } = Route.useParams();
    const navigate = useNavigate();
    const { can } = usePermissions();
    // The same query the list underneath renders from; the gallery needs it to mark templates the
    // org already has as installed.
    const { data } = useQuery(trpcOptions.register.listRegisters.queryOptions());

    if (!can('register:update')) {
        return <Navigate to="/console/$orgId/compliance/registers" params={{ orgId }} replace />;
    }

    const installedTemplateKeys = (data?.rows ?? [])
        .map((register) => register.templateKey)
        .filter((key): key is string => key !== null);

    return (
        <PageController route={Route}>
            <RegisterTemplateGallery
                loading={!data}
                installedTemplateKeys={installedTemplateKeys}
                afterClose={() => navigate({ moveInMatches: -1 })}
                onInstalled={(registerId) =>
                    void navigate({
                        to: '/console/$orgId/compliance/registers/$registerId',
                        params: { orgId, registerId },
                    })
                }
                onStartFromScratch={() =>
                    void navigate({ to: '/console/$orgId/compliance/registers/new', params: { orgId }, replace: true })
                }
            />
        </PageController>
    );
}
